export class GameTypes {
  static readonly GAME360 = "360";
  static readonly ESG = "esg";
  static readonly ELEARNING: string = "pro";
}
